import { lazy } from "react";
import { Outlet } from "react-router-dom";
import { AuthorizationContextProvider, withPageLoader } from "@tecorien/mimic";
import { SiteLayout } from "components/layouts/SiteLayout";
import { links } from "links";
import { RouteDescription } from "types";

const NotFoundPage = lazy(() => import("../system/NotFoundPage"));

const Home = lazy(() => import("./Home"));
const Attachment = lazy(() => import("./Attachment"));
const PACEOrientationAndDriverTrainingPage = lazy(() => import("./PACEOrientationAndDriverTrainingPage"));
const CLCodeOfConductPage = lazy(() => import("./CLCodeOfConductPage"));

export const publicRoutes: RouteDescription[] = [
  {
    path: links.public,
    element: (
      <SiteLayout
        rootLink={links.public}
        hideMenu
        hideProfile
      >
        <AuthorizationContextProvider>
          <Outlet />
        </AuthorizationContextProvider>
      </SiteLayout>
    ),
    children: [
      {
        path: `${links.publicAttachment}/:id`,
        element: withPageLoader(<Attachment />, false),
      },
      {
        path: links.publicPACEOrientationAndDriverTraining,
        element: withPageLoader(<PACEOrientationAndDriverTrainingPage />, false),
      },
      {
        path: links.publicCLCodeOfConduct,
        element: withPageLoader(<CLCodeOfConductPage />, false),
      },
      {
        path: "*",
        element: withPageLoader(<NotFoundPage homePageUrl={links.public} />),
      },
      {
        index: true,
        element: withPageLoader(<Home />),
      },
    ],
  },
];
